import styled from 'styled-components';

export const StyledWhatsapp = styled.div``;
